import React, { Component } from 'react'
import { translate } from '../utils/useful'

export default class StageQueue extends Component {
    state = {
        pause: {},
        DownloaderStatus: [
            { progress: '70%', bgcolor: 'rgb(113, 200, 240)', status: '5.3GB' },
            { progress: '63%', bgcolor: 'rgb(113, 200, 240)', status: '4.3 / 5.3GB' },
            { progress: '70%', bgcolor: 'rgb(232, 60, 60)', status: 'Failed' },
        ]
    }
    handlePause = (index) => {
        let pause = this.state.pause
        pause[index] = !pause[index]
        this.setState({ pause })
    }
    render() {
        return (
            <div className='py-2 px-4'>
                <div className=' w-100'>
                    {this.state.DownloaderStatus.map((prop, index) => {
                        return (
                            <>
                                <div className='flexcb w-100'>
                                    <div className='flexc mrd-4 w-100' >
                                        <img className='mrd-4' height='50px' src="/images/file.png" alt="" />
                                        <div className='w-100'>
                                            <p className='mb-0 text-smaller'>File Name</p>

                                            <div className='w-100 flexc br-10 mrd-4 flex-1' style={{ height: '10px', overflow: 'hidden', background: 'rgba(239, 239, 239, 0.5)' }}>
                                                <div style={{ background: prop.bgcolor, width: prop.progress, height: '10px' }}>
                                                </div>
                                            </div>
                                            <div className='flexcb'>
                                                <p className='text-smaller' style={{ width: '100px', whiteSpace: 'nowrap' }}>{prop.status}</p>
                                                <div className='flexc'>
                                                    <p className=' text-smaller cursor-pointer' onClick={() => this.handlePause(index)} style={{ display: this.state.pause[index] ? 'none' : '' }}>{translate(`Paused`)}</p>
                                                    <p className=' text-smaller cursor-pointer' onClick={() => this.handlePause(index)} style={{ display: this.state.pause[index] ? '' : 'none' }}>{translate(`Resume`)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flexc'>
                                        <div onClick={() => this.handlePause(index)} style={{ display: this.state.pause[index] ? 'none' : '' }} className='mld-4 flexc cursor-pointer'>
                                            <img height="20px" src="/images/play.png" alt="" />
                                        </div>
                                        <div onClick={() => this.handlePause(index)} style={{ display: this.state.pause[index] ? '' : 'none' }} className='mld-4 flexc cursor-pointer'>
                                            <img height="20px" src="/images/pause.png" alt="" />
                                        </div>
                                        <div className='mld-4'>
                                            <img className='cursor-pointer' height="13px" src="/images/close.png" alt="" />
                                        </div>
                                    </div>

                                </div>

                                <div className='py-2' style={{ borderBottom: '1px solid rgba(244, 227, 227 , 0.3)' }}></div>
                            </>
                        )
                    })}
                </div>
            </div>
        )
    }
}
